<app-delete-confirmation-dialog #createLocationDialog title="{{ 'admin.create_location' | transloco }}"
    body="{{ 'admin.create_location_confirm' | transloco }}" [showBinIcon]="false" [modalDialogId]="'createLocationDialog'"></app-delete-confirmation-dialog>
<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-5 rounded-xl flex flex-col gap-2 font-[Gilroy] h-auto bg-[#FFFFFF]">
            <div class="flex w-full justify-between items-center">
                <p class="text-primary font-semibold text-lg">
                    {{ 'admin.create_location' | transloco }}
                </p>

                <button (click)="closeModal()"><img src="assets/icons/close-circle-black.svg" alt="X"></button>
            </div>
            <div class="w-full flex flex-col gap-2">
                <!-- First row -->
                <div class="w-full flex flex-wrap gap-2">
                    <!-- Street input -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input labelText="{{ 'shared.labels.street' | transloco }}" [inputId]="'street'"
                            [inputType]="'text'" [(inputValue)]="streetInput" [errorMessage]="streetInputError"
                            placeholder="{{ 'shared.placeholders.street' | transloco }}"></app-labeled-input>
                    </div>
                    <!-- Nr input -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input labelText="{{ 'shared.labels.street_number' | transloco }}"
                            [inputId]="'streetNumber'" [inputType]="'text'" [(inputValue)]="streetNumberInput"
                            [errorMessage]="streetNumberInputError"
                            placeholder="{{ 'shared.placeholders.street_number' | transloco }}"></app-labeled-input>
                    </div>
                    <!-- Postal Code input -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input labelText="{{ 'shared.labels.postal_code' | transloco }}"
                            [inputId]="'postalCode'" [inputType]="'text'" [(inputValue)]="postalCodeInput"
                            [errorMessage]="postalCodeInputError"
                            placeholder="{{ 'shared.placeholders.postal_code' | transloco }}"></app-labeled-input>
                    </div>
                </div>
                <!-- Second row -->
                <div class="w-full flex flex-wrap gap-2">
                    <!-- City input -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input labelText="{{ 'shared.labels.city' | transloco }}" [inputId]="'city'"
                            [inputType]="'text'" [(inputValue)]="cityInput" [errorMessage]="cityInputError"
                            placeholder="{{ 'shared.placeholders.city' | transloco }}"></app-labeled-input>
                    </div>
                    <!-- Province input -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input labelText="{{ 'shared.labels.province' | transloco }}" [inputId]="'province'"
                            [inputType]="'text'" [(inputValue)]="provinceInput" [errorMessage]="provinceInputError"
                            placeholder="{{ 'shared.placeholders.province' | transloco }}"></app-labeled-input>
                    </div>
                </div>

                <p *ngIf="editLocation" class="text-warning-700">{{ 'admin.location_warning_message' | transloco }}</p>
                <p>{{ 'admin.create_location_desc' | transloco }}</p>
                <div class="w-full flex justify-center mt-2">
                    <div class="w-full h-[45px] max-w-[500px]">
                        <app-custom-button buttonText="{{ 'shared.confirm' | transloco }}"
                            (buttonClick)="confirmButtonClick()" backgroundColor="bg-primary" textColor="text-white"
                            borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                            [isDisabled]="confirmClicked"></app-custom-button>
                    </div>
                </div>
            </div>

            <!-- Error message -->
            <div *ngIf="dialogErrorMessage" class="flex items-center text-error mt-2 text-sm">
                <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
                    class="w-5 h-5" />
                <p class="ml-1">{{ dialogErrorMessage }}</p>
            </div>
        </div>
    </ng-template></p-dialog>